{
  "version": "1",
  "name": "Using QAOA to solve a UD-MIS problem: final iteration",
  "register": [
    { "name": "0", "x": 0.0, "y": 0.0 },
    { "name": "1", "x": -4.0, "y": -7.0 },
    { "name": "2", "x": 4.0, "y": -7.0 },
    { "name": "3", "x": 8.0, "y": 6.0 },
    { "name": "4", "x": -8.0, "y": 6.0 }
  ],
  "channels": { "ch0": "rydberg_global" },
  "variables": {},
  "operations": [
    {
      "op": "pulse",
      "channel": "ch0",
      "protocol": "min-delay",
      "amplitude": { "kind": "constant", "duration": 7000, "value": 1.0 },
      "detuning": { "kind": "constant", "duration": 7000, "value": 0.0 },
      "phase": 0.0,
      "post_phase_shift": 0.0
    },
    {
      "op": "pulse",
      "channel": "ch0",
      "protocol": "min-delay",
      "amplitude": { "kind": "constant", "duration": 1000, "value": 1.0 },
      "detuning": { "kind": "constant", "duration": 1000, "value": 1.0 },
      "phase": 0.0,
      "post_phase_shift": 0.0
    },
    {
      "op": "pulse",
      "channel": "ch0",
      "protocol": "min-delay",
      "amplitude": { "kind": "constant", "duration": 10000, "value": 1.0 },
      "detuning": { "kind": "constant", "duration": 10000, "value": 0.0 },
      "phase": 0.0,
      "post_phase_shift": 0.0
    },
    {
      "op": "pulse",
      "channel": "ch0",
      "protocol": "min-delay",
      "amplitude": { "kind": "constant", "duration": 3000, "value": 1.0 },
      "detuning": { "kind": "constant", "duration": 3000, "value": 1.0 },
      "phase": 0.0,
      "post_phase_shift": 0.0
    }
  ],
  "measurement": "ground-rydberg",
  "device": "MockDevice"
}
